<template>
	<div>
		<botao-tooltip
			id="botao-excluir"
			icone="mdi-delete"
			v-if="!isAtaCancelada"
			v-az-auth="permissoes.ataFiscaisExcluir"
			cor="grey"
			texto="Excluir"
			@click="$emit('excluir', item)"
		></botao-tooltip>
	</div>
</template>

<script>
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import BotaoTooltip from '@/views/components/BotaoTooltip.vue'

export default {
	name: 'listagem-fiscais-botoes-acoes',
	components: { BotaoTooltip },
	mixins: [permissoesMixin],
	props: {
		item: {
			type: Object,
			required: true,
		},
		isAtaCancelada: {
			type: Boolean,
			default: false,
		},
	},
}
</script>

<style scoped lang="stylus">
.justify-content-center
	justify-content center
</style>
